
import { DossierConfigService } from "@/services/dossier-config-service";
import { SaleLayoutCol } from "@/utils/sale-layouts/col";
import Vue from "vue";
import { SaleLayoutConf } from "@/models/sale-layout";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import AppDetailSettingsImage from "./DetailSettingsImage.vue";
import AppDetailSettingsCols from "./DetailSettingsCols.vue";
import { SaleService } from "@/services";

export default Vue.extend({
	data() {
		return {
			toEditCol: null as null | SaleLayoutCol,
			selectedLanguage: DossierConfigService.getLanguages().LanguageNames[0],
		};
	},
	props: {
		layout: {
			type: Object as ()=>SaleLayout,
			required: true,
		},
		fullControl: Boolean
	},
	computed: {
		title(): string {
			return this.$ct("sale-detail").toString();
		},
	},
	methods: {
		async reset() {
			let confirm = await this.$wf.confirm(this.$ct("reset-to-defaults-confirm"), this.$t("common.yes"), this.$t("common.no"), this.$ct("common.warning"), "warning");
			if (confirm) {
				let saleLayout = new SaleLayoutConf();
				saleLayout.Data = await SaleService.getDefaultSaleLayout();
				this.$emit("update:cols", saleLayout.Data.Cols);
			}
		}
	},
	components: {
		AppDetailSettingsCols,
		AppDetailSettingsImage
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
